<template>
  <div
    v-if="isCurrentStore"
    class="selected-store"
  >
    <q-tabs
      v-model="currentTab"
      align="left"
    >
      <q-tab
        v-for="(tab, index) in tabs"
        :key="index"
        :name="tab.name"
        :label="tab.label"
      />
    </q-tabs>
    <div class="content-block">
      <component
        :is="currentTab"
        class="component"
        @create-zone="$emit('create-zone')"
        @edit-zone="$emit('edit-zone', $event)"
        @remove-zone="$emit('remove-zone', $event)"
      />
    </div>
  </div>
</template>

<script>
/**
 * Компонент отображает магазин (зоны, интервалы доставки, настройки)
 * @module PageShop/Component/SelectedStore
 * @module PageShop/components/SelectedStore/Zones
 * @module PageShop/components/SelectedStore/Pickup
 * @module PageShop/components/SelectedStore/Settings
 * @requires vuex
 * @vue-prop {Number} selectedStoreId - id выбранного магазина
 * @vue-data {Array} tabs - массив вкладок (зоны, самовывоз, настройки)
 * @vue-data {String} currentTab - текущая выбранная вкладка
 * @vue-computed {Boolean} isCurrentStore - есть ли магазин
 */
import { mapActions, mapState } from 'vuex'
import Zones from 'PageShop/components/SelectedStore/Zones'
import Pickup from 'PageShop/components/SelectedStore/Pickup'
import Settings from 'PageShop/components/SelectedStore/Settings'

export default {
  name: 'SelectedStore',
  components: {
    Zones,
    Pickup,
    Settings
  },
  props: {
    selectedStoreId: {
      type: String,
      required: true
    }
  },
  data: () => ({
    tabs: [
      {
        name: 'Zones',
        label: 'Зоны доставки'
      },
      {
        name: 'Pickup',
        label: 'Самовывоз'
      },
      {
        name: 'Settings',
        label: 'Настройки'
      }
    ],
    currentTab: 'Zones'
  }),
  computed: {
    ...mapState('storeModule', ['currentStore']),
    isCurrentStore() { return !!this.currentStore }
  },
  watch: {
    selectedStoreId() {
      this.initStore(this.selectedStoreId)
      this.currentTab = 'Zones'
    }
  },
  created() {
    this.initStore(this.selectedStoreId)
  },
  methods: {
    ...mapActions('storeModule', ['getStoreById']),
    ...mapActions('storeModule/zonesModule', ['getZones']),
    ...mapActions('storeModule/pickupModule', ['getPickups']),
    ...mapActions('storeModule/settingsModule', ['getSettings']),
    /**
     * Инициализирует магазин
     * Запрашивает данные по магазину
     * Запрашивает данные по зонам
     * Запрашивает данные по самовывозам
     * Запрашивает данные по настройкам магазина
     */
    initStore(storeId) {
      this.getStoreById(storeId)
      this.getZones(storeId)
      this.getPickups(storeId)
      this.getSettings(storeId)
    }
  }
}
</script>

<style lang="scss" scoped>
.selected-store {
  display: flex;
  flex-flow: column;
  height: 100%;

  .content-block {
    height: 100%;
    width: 100%;
    overflow-y: auto;
  }
}
</style>
